import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import AssignTechnicianToInstallation, {
    AssignTechnicianToInstallationProps
} from "../../../pages/consumers/installations/components/Installations/AssignTechnicianToInstallation";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, AssignTechnicianToInstallationProps {
}

type Props = OwnProps;

// @ts-ignore
const AssignTechnicianToInstallationModal = NiceModal.create<Props>(({installation, header, onClose}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver title={header} onClose={handleClose} open={modal.visible} afterClose={modal.remove}>
            <AssignTechnicianToInstallation installation={installation}/>
        </SlideOver>
    )
})

export default AssignTechnicianToInstallationModal;
